<template>
  <div class="scheduleEditDefault">
    <el-dialog
      :title="`${form.type === 'add' ? '新增' : '编辑'}理疗执行排班`"
      :visible.sync="visible"
      width="680px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :before-close="close">
      <div class="content" v-loading="loading">
        <el-form ref="form" class="form" :model="form" :rules="rules" label-width="70px" hide-required-asterisk>
          <el-form-item v-if="application === 'rules' && form.type === 'add'" label="排班至" prop="weeks">
            <el-checkbox-group v-model="form.weeks" @change="resetAppointmentTime">
              <el-checkbox-button v-for="week in weeks" :key="week.value" :label="week.value">{{ week.label }}</el-checkbox-button>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item v-if="application === 'rules' && form.type === 'edit'" label="排班至" prop="week">
            <el-select class="form_week" v-model="form.week" placeholder="请选择" @change="resetAppointmentTime">
              <el-option
                v-for="week in weeks"
                :key="week.value"
                :label="week.label"
                :value="week.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="application === 'scheduling' && form.type === 'add'" label="排班至" prop="schedulingTimes">
            <div class="form_schedulingTimes_sector">
              <el-date-picker
                class="form_schedulingTimes"
                v-model="form.schedulingTimes"
                type="dates"
                format="MM-dd"
                value-format="yyyy-MM-dd"
                :picker-options="schedulingTimeOptions"
                placeholder="请选择"
                :clearable="false"
                @change="resetAppointmentTime">
              </el-date-picker>
              <div class="form_schedulingTimes_tips">
                <span class="el-icon-warning-outline form_schedulingTimes_tips_icon"></span>
                <span class="form_schedulingTimes_tips_text">可多选日期</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item v-if="application === 'scheduling' && form.type === 'edit'" label="排班至" prop="schedulingTime">
            <el-date-picker
              class="form_schedulingTime"
              v-model="form.schedulingTime"
              type="date"
              format="MM-dd"
              value-format="yyyy-MM-dd"
              :picker-options="schedulingTimeOptions"
              placeholder="请选择"
              :clearable="false"
              disabled
              @change="resetAppointmentTime">
            </el-date-picker>
          </el-form-item>
          <div class="form_period">
            <el-form-item prop="time" label="排班时段" class="form_period_time" :rules="validateAppointmentTime()">
              <div class="form_period_time_item">
                <el-form-item prop="appointmentStartTime" :rules="{ required: true, message: '请选择', trigger: 'change' }">
                  <el-time-select
                    class="form_time_select form_period_time_select"
                    v-model="form.appointmentStartTime"
                    :editable="false"
                    :clearable="false"
                    :picker-options="{ start: '08:00', end: '21:30' }"
                    value-format="HH:mm"
                    placeholder="开始时间"
                    :disabled="form.isRegistration"
                    @change="appointmentTimeChange">
                  </el-time-select>
                </el-form-item>
                <span class="form_period_time_split">-</span>
                <el-form-item prop="appointmentEndTime" :rules="{ required: true, message: '请选择', trigger: 'change' }">
                  <el-time-select
                    class="form_time_select form_period_time_select"
                    v-model="form.appointmentEndTime"
                    :editable="false"
                    :clearable="false"
                    :picker-options="{ start: '08:00', end: '24:00' }"
                    value-format="HH:mm"
                    placeholder="结束时间"
                    :disabled="form.isRegistration"
                    @change="appointmentTimeChange">
                  </el-time-select>
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item label-width="0px" prop="timeType" class="form_period_timeType">
              <el-select class="form_period_type" v-model="form.timeType" placeholder="时段" :disabled="form.isRegistration">
                <el-option
                  v-for="type in timeTypeList"
                  :key="type.value"
                  :label="type.label"
                  :value="type.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label="坐诊诊室" prop="clinicId">
            <el-select class="form_select" v-model="form.clinicId" placeholder="请选择" @change="clinicChange">
              <el-option
                v-for="clinic in clinicList"
                :key="clinic.clinicId"
                :label="clinic.clinicName"
                :value="clinic.clinicId">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="form_allocation">
            <el-form-item label="放号时间" prop="releaseDay">
              <el-input class="form_allocation_day" v-model.trim="form.releaseDay" @input="val => form.releaseDay = val.replace(/\D/g, '')" :disabled="Date.now() > new Date(form.releaseTime).getTime()">
                <template slot="append">天</template>
              </el-input>
              <div v-if="Date.now() > new Date(form.releaseTime).getTime()" class="form_item_tips">已放号，不允许修改</div>
            </el-form-item>
            <el-form-item label-width="0px" prop="releasePointTime">
              <el-time-select
                class="form_time_select form_allocation_time"
                v-model="form.releasePointTime"
                :editable="false"
                :clearable="false"
                :picker-options="{ start: '00:00', end: '23:50', step: '00:10' }"
                value-format="HH:mm"
                placeholder="放号时间"
                :disabled="Date.now() > new Date(form.releaseTime).getTime()">
              </el-time-select>
            </el-form-item>
          </div>
          <div class="form_bed">
            <el-form-item label="独立床位">
              <div class="form_bed_row">
                <div class="form_bed_input">
                  <el-form-item prop="bedIndependenceNumber">
                    <el-input class="form_bed_num" v-model.trim="form.bedIndependenceNumber" @input="val => form.bedIndependenceNumber = val.replace(/\D/g, '')">
                      <template slot="append">个</template>
                    </el-input>
                  </el-form-item>
                </div>
                <div class="form_bed_tiips">（当前可分配床位数{{ bedMap.allotBedNumber }}个）</div>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { clinicList } from "@/api/clinic"
  import { getDayAllotBedNumber, getWeekAllotBedNumber } from '@/api/schedule'
  export default {
    name: 'scheduleEditDefault',
    props: {
      // scheduling: 排班; rules: 规则
      application: {
        type: String,
        default: 'scheduling'
      }
    },
    data () {
      var validateBedNumber = (rule, value, callback) => {
        if (value > this.bedMap.allotBedNumber) {
          callback(new Error('不可大于可分配床位数'))
        } else {
          callback()
        }
      }
      return {
        visible: false,
        loading: false,
        weeks: [
          { label: '周一', value: 'monday' },
          { label: '周二', value: 'tuesday' },
          { label: '周三', value: 'wednesday' },
          { label: '周四', value: 'thursday' },
          { label: '周五', value: 'friday' },
          { label: '周六', value: 'saturday' },
          { label: '周日', value: 'sunday' }
        ],
        schedulingTimeOptions: {
          disabledDate: date => {
            return date && date.getTime() < Date.now() - (24 * 60 * 60 * 1000) || date && date.getTime() > Date.now() + 59 * (24 * 60 * 60 * 1000)
          }
        },
        timeTypeList: [
          { label: '上午', value: '1' },
          { label: '中午', value: '2' },
          { label: '下午', value: '3' },
          { label: '晚上', value: '4' }
        ],
        clinicList: [],
        rules: {
          weeks: [{ required: true, message: '请选择', trigger: 'change' }],
          week: [{ required: true, message: '请选择', trigger: 'change' }],
          schedulingTimes: [{ required: true, message: '请选择', trigger: 'change' }],
          schedulingTime: [{ required: true, message: '请选择', trigger: 'change' }],
          timeType: [{ required: true, message: '请选择', trigger: 'change' }],
          clinicId: [{ required: true, message: '请选择', trigger: 'change' }],
          releaseDay: [{ required: true, message: '请输入放号时间', trigger: 'blur' }],
          releasePointTime: [{ required: true, message: '请选择', trigger: 'change' }],
          bedIndependenceNumber: [{ validator: validateBedNumber, trigger: 'blur' }]
        },
        appointmentValidate: {
          isError: false,
          message: ''
        },
        bedMap: {
          allotBedNumber: 0
        },
        doctorId: '',
        form: {
          type: 'add',
          originWeek: '',
          vId: '',
          id: '',
          schedulingItemId: '',
          weeks: [],
          week: '',
          schedulingTimes: [],
          schedulingTime: '',
          timeType: '1',
          appointmentStartTime: '',
          appointmentEndTime: '',
          clinicId: '',
          clinicName: '',
          releaseDay: '15',
          releasePointTime: '00:00',
          releaseTime: '',
          ruleType: '2',
          isStop: false,
          isRegistration: false,
          bedIndependenceNumber: null
        }
      }
    },
    methods: {
      init (info) {
        this.visible = true
        this.loading = false
        this.getClinicList()
        this.$nextTick(() => {
          if (info) {
            const data = JSON.parse(JSON.stringify(info))

            this.doctorId = data.doctorId || ''

            this.form.type = data.type || 'add'
            this.form.originWeek = data.week || ''
            this.form.vId = data.vId || ''
            this.form.id = data.id || ''
            this.form.schedulingItemId = data.schedulingItemId || ''
            this.form.weeks = data.week && [data.week] || []
            this.form.week = data.week && data.week || ''

            if (data.ruleTime) {
              this.form.timeType = data.ruleTime.timeType || '1'
              this.form.appointmentStartTime = data.ruleTime.appointmentStartTime && data.ruleTime.appointmentStartTime.substring(0, 5) || ''
              this.form.appointmentEndTime = data.ruleTime.appointmentEndTime && data.ruleTime.appointmentEndTime.substring(0, 5) || ''
              this.form.releaseDay = !['', undefined, null].includes(data.ruleTime.releaseDay) ? data.ruleTime.releaseDay : '15'
              this.form.releasePointTime = data.ruleTime.releasePointTime && data.ruleTime.releasePointTime.substring(0, 5) || '00:00'
            }
            if (data.schedulingItemDateTime) {
              this.form.schedulingTimes = data.schedulingItemDateTime.schedulingTime && [data.schedulingItemDateTime.schedulingTime] || []
              this.form.schedulingTime = data.schedulingItemDateTime.schedulingTime || ''
              this.form.timeType = data.schedulingItemDateTime.timeType || '1'
              this.form.appointmentStartTime = data.schedulingItemDateTime.appointmentStartTime && data.schedulingItemDateTime.appointmentStartTime.substring(0, 5) || ''
              this.form.appointmentEndTime = data.schedulingItemDateTime.appointmentEndTime && data.schedulingItemDateTime.appointmentEndTime.substring(0, 5) || ''
              this.form.releaseDay = !['', undefined, null].includes(data.schedulingItemDateTime.releaseDay) ? data.schedulingItemDateTime.releaseDay : '15'
              this.form.releasePointTime = data.schedulingItemDateTime.releasePointTime && data.schedulingItemDateTime.releasePointTime.substring(0, 5) || '00:00'
              this.form.releaseTime = data.schedulingItemDateTime.releaseTime || ''
            }

            this.form.clinicId = data.clinic && data.clinic.clinicId || ''
            this.form.clinicName = data.clinic && data.clinic.clinicName || ''

            this.form.isStop = data.isStop || false
            this.form.isRegistration = data.isRegistration || false

            this.form.bedIndependenceNumber = !['', null, undefined].includes(data.bedIndependenceNumber) ? data.bedIndependenceNumber : 0

            this.getAllotBed()
          }
        })
      },
      setLoading (status) {
        this.loading = status
      },
      async getClinicList () {
        const res = await clinicList({})
        if (res.code === 200) {
          this.clinicList = res.rows
        }
      },
      clinicChange (value) {
        const clinic = this.clinicList.find(item => item.clinicId === value)
        if (clinic) {
          this.form.clinicName = clinic.clinicName
        }
      },
      async getAllotBed () {
        if (this.application === 'rules') {
          if (this.form.type === 'add' && this.form.weeks && this.form.weeks.length <= 0) {
            return false
          }
          if (this.form.type === 'edit' && ['', null, undefined].includes(this.form.week)) {
            return false
          }
        } else if (this.application === 'scheduling') {
          if (this.form.type === 'add' && this.form.schedulingTimes && this.form.schedulingTimes.length <= 0) {
            return false
          }
          if (this.form.type === 'edit' && ['', null, undefined].includes(this.form.schedulingTime)) {
            return false
          }
        }

        if (!(this.form.appointmentStartTime && this.form.appointmentEndTime && this.form.appointmentStartTime < this.form.appointmentEndTime)) {
          return false
        }

        let res = null

        if (this.application === 'rules') {
          let allotNumberDetails = []

          if (this.form.type === 'add') {
            this.form.weeks.forEach(v => {
              allotNumberDetails.push({
                week: v,
                appointmentStartTime: `${this.form.appointmentStartTime}:00`,
                appointmentEndTime: `${this.form.appointmentEndTime}:00`
              })
            })
          } else {
            allotNumberDetails.push({
              week: this.form.week,
              appointmentStartTime: `${this.form.appointmentStartTime}:00`,
              appointmentEndTime: `${this.form.appointmentEndTime}:00`
            })
          }

          res = await getWeekAllotBedNumber({
            deptId: sessionStorage.getItem('deptId'),
            doctorId: this.doctorId,
            allotNumberDetails: allotNumberDetails
          })
        } else if (this.application === 'scheduling') {
          let allotNumberDetails = []

          if (this.form.type === 'add') {
            this.form.schedulingTimes.forEach(v => {
              allotNumberDetails.push({
                schedulingItemId: this.form.schedulingItemId || null,
                appointmentStartDateTime: `${v} ${this.form.appointmentStartTime}:00`,
                appointmentEndDateTime: `${v} ${this.form.appointmentEndTime}:00`
              })
            })
          } else {
            allotNumberDetails.push({
              schedulingItemId: this.form.schedulingItemId || null,
              appointmentStartDateTime: `${this.form.schedulingTime} ${this.form.appointmentStartTime}:00`,
              appointmentEndDateTime: `${this.form.schedulingTime} ${this.form.appointmentEndTime}:00`
            })
          }

          res = await getDayAllotBedNumber({
            deptId: sessionStorage.getItem('deptId'),
            allotNumberDetails: allotNumberDetails
          })
        }

        if (res.code === 200) {
          this.bedMap.allotBedNumber = res.data.allotBedNumber || 0
          if (!['', '0', 0, null, undefined].includes(this.form.bedIndependenceNumber)) {
            this.$refs['form'].validateField('bedIndependenceNumber')
          }
        }
      },
      validateAppointment (message) {
        this.appointmentValidate.isError = true
        this.appointmentValidate.message = message || ''
        this.$refs['form'].validateField('time')
      },
      resetAppointmentTime () {
        this.appointmentValidate.isError = false
        this.appointmentValidate.message = ''
        this.$refs['form'].validateField('time')
        this.getAllotBed()
      },
      forecastPeriodType () {
        const periodRangeMap = {
          '1': { start: 8 * 60, end: 13 * 60 },
          '3': { start: 13 * 60, end: 18 * 60 },
          '4': { start: 18 * 60, end: 24 * 60 }
        }
        const toMinutes = (timeStr) => {
          if ([null, undefined, ''].includes(timeStr)) {
            return null
          }
          const parts = String(timeStr).split(':')
          const h = parseInt(parts[0], 10)
          const m = parseInt(parts[1], 10)
          if (Number.isNaN(h) || Number.isNaN(m)) {
            return null
          }
          return h * 60 + m
        }
        const startMin = toMinutes(this.form.appointmentStartTime)
        const endMin = toMinutes(this.form.appointmentEndTime)
        if (startMin === null || endMin === null) {
          return null
        }

        const a0 = Math.min(startMin, endMin)
        const a1 = Math.max(startMin, endMin)

        const timeTypeList = this.timeTypeList.map(t => {
          const pr = periodRangeMap[t.value]
          if (!pr) {
            return null
          }
          const intersection = Math.max(0, Math.min(a1, pr.end) - Math.max(a0, pr.start))
          return { key: t.value, start: pr.start, end: pr.end, intersection }
        }).filter(Boolean)

        let bestKey = null
        let bestIntersection = -1
        for (const row of timeTypeList) {
          if (row.intersection > bestIntersection) {
            bestIntersection = row.intersection
            bestKey = row.key
          }
        }
        if (bestKey !== null) {
          this.form.timeType = bestKey
        }
      },
      appointmentTimeChange () {
        if (![null, undefined, ''].includes(this.form.appointmentStartTime) && ![null, undefined, ''].includes(this.form.appointmentEndTime)) {
          this.forecastPeriodType()
        }
        this.appointmentValidate.isError = false
        this.appointmentValidate.message = ''
        this.$refs['form'].validateField('time')
        this.getAllotBed()
      },
      validateAppointmentTime () {
        return [{
          validator: (rule, value, callback) => {
            if ([null, undefined, ''].includes(this.form.appointmentStartTime) || [null, undefined, ''].includes(this.form.appointmentEndTime)) {
              callback()
            }
            if (this.form.appointmentStartTime > this.form.appointmentEndTime) {
              callback(new Error('开始时间不能大于结束时间'))
            } else if (this.form.appointmentStartTime === this.form.appointmentEndTime) {
              callback(new Error('开始时间不能等于结束时间'))
            } else {
              if (this.appointmentValidate.isError) {
                callback(new Error(this.appointmentValidate.message))
              } else {
                callback()
              }
            }
          },
          trigger: 'change'
        }]
      },
      submit() {
        this.$refs['form'].validate(valid => {
          if (valid) {
            this.$emit('submit', JSON.parse(JSON.stringify({
              ...this.form,
              bedIndependenceNumber: !['', null, undefined].includes(this.form.bedIndependenceNumber) ? this.form.bedIndependenceNumber : 0
            })))
          }
        })
      },
      close () {
        this.visible = false
        this.bedMap = {
          allotBedNumber: 0
        }
        this.form = {
          type: 'add',
          originWeek: '',
          vId: '',
          id: '',
          schedulingItemId: '',
          weeks: [],
          week: '',
          schedulingTimes: [],
          schedulingTime: '',
          timeType: '1',
          appointmentStartTime: '',
          appointmentEndTime: '',
          clinicId: '',
          clinicName: '',
          releaseDay: '15',
          releasePointTime: '00:00',
          releaseTime: '',
          ruleType: '2',
          isStop: false,
          isRegistration: false,
          bedIndependenceNumber: null
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .scheduleEditDefault /deep/ .el-dialog__header {
    padding: 12px 24px;
    border-bottom: 1px solid #E0E0E0 !important;
  }

  .scheduleEditDefault /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .scheduleEditDefault /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 18px;
    height: 16px;
  }

  .scheduleEditDefault /deep/ .el-dialog__body {
    padding: 0;
  }

  .scheduleEditDefault /deep/ .el-dialog__footer {
    padding: 12px 16px;
    border-top: 1px solid #E0E0E0;
  }

  .content {
    padding: 20px 24px;
  }

  .form {
    overflow: hidden;
  }

  .form /deep/ .el-form-item__label {
    line-height: 32px;
    color: #667182;
  }

  .form /deep/ .el-form-item__content {
    line-height: 32px;
  }

  .form_select {
    width: 170px;
  }

  .form_time_select /deep/ .el-input__inner {
    padding: 0 12px !important;
  }

  .form_time_select /deep/ .el-input__prefix, .form_time_select /deep/ .el-input__suffix {
    display: none;
  }

  .form_week {
    width: 140px;
  }

  .form_schedulingTimes_sector {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .form_schedulingTimes {
    width: 270px;
  }

  .form_schedulingTimes_tips {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 0 0 12px;
  }

  .form_schedulingTimes_tips_icon {
    font-size: 14px;
    color: #1890FF;
  }

  .form_schedulingTimes_tips_text {
    margin: 0 0 0 2px;
    font-size: 13px;
    color: #667182;
  }

  .form_schedulingTime {
    width: 170px;
  }

  .form_period {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .form_period_type {
    width: 80px;
  }

  .form_period_time {
    
  }

  .form_period_time_item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .form_period_time_select {
    width: 82px;
  }

  .form_period_time_split {
    margin: 0 4px;
    font-size: 12px;
    color: #595F68;
  }

  .form_period_timeType {
    margin-left: 12px;
  }

  .form_item_tips {
    position: absolute;
    top: 100%;
    left: 0;
    padding-top: 4px;
    line-height: 1;
    font-size: 12px;
    color: #f54a45;
  }

  .form_allocation {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .form_allocation_day {
    width: 170px;
  }

  .form_allocation_time {
    margin: 0 0 0 12px;
    width: 80px;
  }

  .form_bed {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .form_bed_row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .form_bed_input {}

  .form_bed_num {
    width: 170px;
  }

  .form_bed_tiips {
    margin: 0 0 0 12px;
    font-size: 13px;
    color: #667182;
    white-space: nowrap;
  }

</style>